import React from 'react'
import { PriceString } from '../../functional/PriceString'
import * as S from './styled'

type ProfitStringProps = {
  value: number
}

export const ProfitString = ({ value }: ProfitStringProps) => {
  const symbol = value > 0 ? '+' : ''

  return (
    <S.Text $value={value}>
      {symbol}
      <PriceString value={value} />
    </S.Text>
  )
}
